import { Injectable, inject } from '@angular/core';

import { useRolloutPlanStore } from '../../../+state/rollout/rollout-plan.store';
import { RolloutPlanValidateDeviceWhiteListRequestDto } from '../../../infrastructure/backends/rollout-plan.dto';

@Injectable({ providedIn: 'root' })
export class DistributionSettingsService {
  private store = inject(useRolloutPlanStore);

  loadValidationsForDeviceWhiteList(requestBody: RolloutPlanValidateDeviceWhiteListRequestDto) {
    return this.store.checkValidityOfDeviceWhitelist(requestBody);
  }
}
